module.exports = __webpack_public_path__ + "media/images/flags/BW-4ca3323012b0469a99b0621f9188cef9.svg";